import React, { Component } from "react";
import {Link} from "react-router-dom";
import DatePicker from 'react-date-picker';
import Select from "react-select";

import './NewJointVisit.scss';
import MyContext from '../MyContext.jsx';
import {epochToDate} from '../../assets/js/handy.mjs';
import CameraComponent from "../AttendanceCamera/CameraComponent";
import axios from 'axios';

class NewJointVisits extends Component {
  constructor(props) {
    super(props);
    this.state = {
      executives : [],
      executive : {},
      routes : [],
      route : {},
      schedules : [],
      blob : null,
    }
  }

  componentDidMount(){   
    $(".react-date-picker__inputGroup input").attr("readonly","true");
    this.getExecutives();    
  }



  getExecutives(){
    const url = `${process.env.REACT_APP_SSS}/api/getJointVisit/executives`;
    this.context.loading(1);
    var obj_this = this;
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid,
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      if(return_data.status == "success"){
        obj_this.setState({
          executives : return_data.executives,
        });
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
     }).fail(function(){
      alert("Network error");
      obj_this.context.loading(0);
      // obj_this.props.history.replace("/");
    });
  }
  executiveChange(option){
    const url = `${process.env.REACT_APP_SSS}/api/getJointVisit/routes`;
    this.context.loading(1);
    var obj_this = this;
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid,
        executive : option?.value 
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      if(return_data.status == "success"){
        obj_this.setState({
          routes : return_data.routes,
          executive : option
        });
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
     }).fail(function(){
      alert("Network error");
      obj_this.context.loading(0);
      // obj_this.props.history.replace("/");
    });

  }

  routeChange(option){
    // console.log(option);
    this.setState({
      route : option
    }); 
  }

  onDateChange(value){
    // console.log(value);
    this.setState({scheduled_date : value});
  }


  formSubmit(e){
    e.preventDefault();
    // console.log(this.state);
    // return;
    // if(!this.state.scheduled_date){
    //   alert('Date required');
    //   return;
    // }
    if(!this.state.executive.value){
      alert('Employee required');
      return;
    }
    if(!this.state.route.value){
      alert('Route required');
      return;
    }

    if(!this.state.blob){
      alert('Please try again with image');
      this.props.history.replace("/jointvisits");
      return;
    }
    var obj_this = this;


    var sid =  obj_this.context.user_details.sid;
    
    var fd = new FormData();

    fd.append('sid',sid);

    fd.append('route', obj_this.state.route.value);

    fd.append('executive', obj_this.state.executive.value);

    fd.append('image',obj_this.state.blob);

    const url = `${process.env.REACT_APP_SSS}/api/jointVisit/save`;
    obj_this.context.loading(1);

    axios.post(url,fd)
      .then(res =>{
        console.log(res.data);
        if(res.data.status == "success"){
          alert("Joint Visit Added");
          obj_this.props.history.replace("/jointvisits");
          obj_this.context.loading(0);
        }
        else if(res.data.status == "already"){
          alert("Joint Visit already Added");
          obj_this.context.loading(0);
        }
        else {
          alert("Error");
          obj_this.context.loading(0);
          obj_this.props.history.replace('/dashboard');
        }
      });
  }
  handleImageCapture = (imageURI) => {
    var obj_this = this;
    if (imageURI.startsWith('file://')) {
      window.resolveLocalFileSystemURL(
          imageURI,
          function(fileEntry) {
              fileEntry.file(
                  function(file) {            
                      const reader = new FileReader();
                      reader.onloadend = function() {
                          const blob = new Blob([new Uint8Array(this.result)], { type: file.type });
                          // console.log(blob)
                          obj_this.setState({
                            blob: blob,
                          });
                      };
                      reader.readAsArrayBuffer(file);
                  },
                  function(error) {
                      console.error('Error reading file:', error);
                  }
              );
          },
          function(error) {
              console.error('Error resolving file URL:', error);
          }
      );
    } else if (imageURI.startsWith('data:image')) {
        fetch(imageURI)
            .then(res => res.blob())
            .then(blob => {
                obj_this.setState({ blob: blob });
            })
            .catch(err => console.error('Error converting data URI to blob:', err));
    } else {
        console.error('Invalid image URI:', imageURI);
    }
  }

  render(){
  return (
    <MyContext.Consumer>
      {context => (
        <div className="new_schedule_container">
          <div className="page_header">

            <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{ marginRight: '15px', cursor: 'pointer' }}></i> Add Joint Visit</div>
          </div> 
          <form className="schedule_form"
            onSubmit={e => this.formSubmit(e)}
          >
            <div className="customer_details_container blocks">

              <div className="input_label">Executives</div>
              <Select 
                options={this.state.executives}  
                value ={this.state.executive}
                className="executives" 
                ref={r => {
                  this.refs = r;
                }}
                onChange={e => this.executiveChange(e)}
                isDisabled = { this.state.schedules.length > 0 ? true : false}
                required
              />
            
              <div className="input_label">Routes</div>
              <Select 
                options={this.state.routes}  
                value ={this.state.route}
                className="route" 
                ref={r => {
                  this.refs = r;
                }}
                onChange={e => this.routeChange(e)}
                required
              />
              {/* <div className="input_label">Date</div>
              <DatePicker
                className="input custom_input"
                onChange={(value) => this.onDateChange(value)}
                value={this.state.scheduled_date}
                minDate = {new Date()}
                required
                clearIcon={true}
                format="dd-MM-y"
              /> */}
              <div className="camera_captue">
                <CameraComponent onImageCapture={this.handleImageCapture}/>
              </div>

            </div>
            <button type="submit" 
            className="submit_button"
            >
              <i className="far fa-save"></i> Submit
            </button>
          </form>           
        </div>
      )}
    </MyContext.Consumer>
  )}
}

export default NewJointVisits;
NewJointVisits.contextType = MyContext;
